<script>
	// 폰(<768px) 전용 상단 가로 탭바. 넘치면 좌우 스크롤. 태블릿/데스크톱은 좌측 BuilderSidebar 사용.
	// 탭 로직은 bot(Bot 인스턴스) 소유 — 여긴 표현만. tabList는 부모에서 enterprise 필터 적용됨.
	export let bot;
	export let tabList = [];
</script>

<nav
	class="tw-flex tw-shrink-0 tw-gap-1 tw-overflow-x-auto tw-border-b tw-border-border tw-bg-background tw-px-3 tw-py-2 md:tw-hidden"
	aria-label="빌더 단계"
>
	{#each tabList as tab (tab.value)}
		<button
			type="button"
			class="tw-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-0.5 tw-whitespace-nowrap tw-rounded-full tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors {bot.isCurrentTab(
				tab.value,
			)
				? 'tw-bg-primary/10 tw-text-primary'
				: 'tw-text-foreground/70 hover:tw-bg-muted hover:tw-text-foreground'}"
			on:click={() => bot.changeCurrentTab(tab.value)}
		>
			{tab.label}{#if tab.required}<span class="tw-text-destructive">*</span>{/if}
		</button>
	{/each}
</nav>
